<template>
    <div class="diff-wrapper">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'DiffCheck',
};
</script>

<style scoped>
.diff-wrapper {
    padding: var(--spacing-lg);
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    border: 1px solid var(--border-light);
}
</style>
